import * as Style from '../Sidebar/style';

function FilterMessageLimits({ limits, setMessageLimits }) {
  return (
    <Style.Form onSubmit={setMessageLimits}>
      <Style.Fieldset>
        <legend>Messages limit</legend>
        <Style.Field>
          <Style.Label htmlFor="lower-limit">Start</Style.Label>
          <Style.Input
            id="lower-limit"
            name="lowerLimit"
            type="number"
            min="1"
            placeholder={limits.low.toString()}
          />
        </Style.Field>
        <Style.Field>
          <Style.Label htmlFor="upper-limit">End</Style.Label>
          <Style.Input
            id="upper-limit"
            name="upperLimit"
            type="number"
            min="1"
            placeholder={limits.high.toString()}
          />
        </Style.Field>
        <Style.Field>
          <Style.Submit type="submit" value="Apply" />
          <Style.InputDescription>
            A high delta may freeze the page for a while, change this with
            caution
          </Style.InputDescription>
        </Style.Field>
      </Style.Fieldset>
    </Style.Form>
  );
}

export default FilterMessageLimits;
